import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	popup: {
		maxWidth: 680,
		width: '90vw',
		maxHeight: '90vh',
		display: 'flex',
		flexDirection: 'column',
	},
	body: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
		overflow: 'hidden',
		flex: 1,
		minHeight: 0,
	},
	previewPanel: {
		position: 'relative',
		flex: 1,
		minHeight: 200,
		border: `1px solid ${THEME.colors.border.main}`,
		borderRadius: THEME.common.borderRadius,
		overflow: 'hidden',
		backgroundColor: THEME.colors.background.light,
	},
	previewFrame: {
		width: '100%',
		height: '100%',
		border: 'none',
	},
	socialScroll: {
		height: '100%',
		overflowY: 'auto',
		...THEME.common.scrollBar,
	},
	blogScroll: {
		height: '100%',
		overflowY: 'auto',
		...THEME.common.scrollBar,
	},
	previewUnavailable: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		height: '100%',
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
	},
	refineSection: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
	},
	refineLabel: {
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
		fontWeight: THEME.typography.fontWeights.semibold,
	},
	refineRow: {
		display: 'flex',
		alignItems: 'flex-end',
		gap: THEME.spacing.sm,
	},
	refineTextArea: {
		flex: 1,
		resize: 'none',
		minHeight: 60,
		maxHeight: 120,
	},
	errorText: {
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.danger.main,
		margin: 0,
	},
	footer: {
		display: 'flex',
		justifyContent: 'space-between',
	},
});
